import { Injectable } from '@angular/core';
import { GlobalGoalsMainGoal } from '../models/question/question-global-goal.model';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BaseGlobalGoalsService {
  getGlobalGoals(): Observable<GlobalGoalsMainGoal[]> {
    return of(globalGoals);
  }
}
const globalGoals: GlobalGoalsMainGoal[] = [
  {
    code: 1,
    nameSv: 'Ingen fattigdom',
    nameEn: 'Ingen fattigdom',
    subGoals: [
      {
        mainGoalCode: 1,
        code: '1_1',
        nameSv:
          'Stärka förutsättningar för socioekonomiskt utsatta personer genom tillgång till ekonomiska resurser, grundläggande tjänster och ny teknik',
        nameEn:
          'Stärka förutsättningar för socioekonomiskt utsatta personer genom tillgång till ekonomiska resurser, grundläggande tjänster och ny teknik',
        originalNameSv:
          '1.4 Senast 2030 säkerställa att alla män och kvinnor, i synnerhet de fattiga och de utsatta, har lika rätt till ekonomiska resurser, tillgång till grundläggande tjänster, möjlighet att äga och kontrollera mark och andra former av egendom samt tillgång till arv, naturresurser, lämplig ny teknik och finansiella tjänster, inklusive mikrokrediter.',
        originalNameEn:
          '1.4 Senast 2030 säkerställa att alla män och kvinnor, i synnerhet de fattiga och de utsatta, har lika rätt till ekonomiska resurser, tillgång till grundläggande tjänster, möjlighet att äga och kontrollera mark och andra former av egendom samt tillgång till arv, naturresurser, lämplig ny teknik och finansiella tjänster, inklusive mikrokrediter.',
      },
      {
        mainGoalCode: 1,
        code: '1_2',
        nameSv:
          'Öka motståndskraften för personer i utsatta situationer såsom ekonomiska, sociala och miljömässiga kriser och katastrofer',
        nameEn:
          'Öka motståndskraften för personer i utsatta situationer såsom ekonomiska, sociala och miljömässiga kriser och katastrofer',
        originalNameSv:
          '1.5 Till 2030 bygga upp motståndskraften hos de fattiga och människor i utsatta situationer och minska deras utsatthet och sårbarhet för extrema klimatrelaterade händelser och andra ekonomiska, sociala och miljömässiga chocker och katastrofer.',
        originalNameEn:
          '1.5 Till 2030 bygga upp motståndskraften hos de fattiga och människor i utsatta situationer och minska deras utsatthet och sårbarhet för extrema klimatrelaterade händelser och andra ekonomiska, sociala och miljömässiga chocker och katastrofer.',
      },
    ],
  },
  {
    code: 2,
    nameSv: 'Ingen hunger',
    nameEn: 'Ingen hunger',
    subGoals: [
      {
        mainGoalCode: 2,
        code: '2_1',
        nameSv: 'Öka tillgången till tillräckligt med säker och näringsrik mat',
        nameEn: 'Öka tillgången till tillräckligt med säker och näringsrik mat',
        originalNameSv:
          '2.1 Senast 2030 avskaffa hunger och garantera alla människor, i synnerhet de fattiga och människor i utsatta situationer, inklusive små barn, tillgång till tillräckligt med säker och näringsrik mat året om.',
        originalNameEn:
          '2.1 Senast 2030 avskaffa hunger och garantera alla människor, i synnerhet de fattiga och människor i utsatta situationer, inklusive små barn, tillgång till tillräckligt med säker och näringsrik mat året om.',
      },
      {
        mainGoalCode: 2,
        code: '2_2',
        nameSv: 'Minska undernäring och näringsbrist',
        nameEn: 'Minska undernäring och näringsbrist',
        originalNameSv:
          '2.2 Senast 2030 avskaffa alla former av undernäring, bland annat genom att senast 2025 nå de internationellt överenskomna målen i fråga om tillväxthämning och undervikt bland barn under fem år, samt tillgodose tonårsflickors, gravida och ammande kvinnors samt äldre personers näringsbehov.',
        originalNameEn:
          '2.2 Senast 2030 avskaffa alla former av undernäring, bland annat genom att senast 2025 nå de internationellt överenskomna målen i fråga om tillväxthämning och undervikt bland barn under fem år, samt tillgodose tonårsflickors, gravida och ammande kvinnors samt äldre personers näringsbehov.',
      },
      {
        mainGoalCode: 2,
        code: '2_3',
        nameSv:
          'Öka tillgången till nödvändiga produktionsresurser, insatsvaror och kunskap på rimliga villkor för livsmedelsproducenter ',
        nameEn:
          'Öka tillgången till nödvändiga produktionsresurser, insatsvaror och kunskap på rimliga villkor för livsmedelsproducenter ',
        originalNameSv:
          '2.3 Till 2030 fördubbla jordbrukets produktivitet och inkomster för småskaliga livsmedelsproducenter, i synnerhet kvinnor, ursprungsfolk, familjejordbrukare, boskapsskötande nomader samt fiskare, inklusive genom säker och lika tillgång till mark, andra produktionsresurser och insatsvaror, kunskap, finansiella tjänster och marknader samt möjligheter till förädling och sysselsättning utanför jordbruket.',
        originalNameEn:
          '2.3 Till 2030 fördubbla jordbrukets produktivitet och inkomster för småskaliga livsmedelsproducenter, i synnerhet kvinnor, ursprungsfolk, familjejordbrukare, boskapsskötande nomader samt fiskare, inklusive genom säker och lika tillgång till mark, andra produktionsresurser och insatsvaror, kunskap, finansiella tjänster och marknader samt möjligheter till förädling och sysselsättning utanför jordbruket.',
      },
      {
        mainGoalCode: 2,
        code: '2_4',
        nameSv: 'Stärka förutsättningar för ökad hållbar livsmedelsproduktion ',
        nameEn: 'Stärka förutsättningar för ökad hållbar livsmedelsproduktion ',
        originalNameSv:
          '2.4 Senast 2030 uppnå hållbara system för livsmedelsproduktion samt införa motståndskraftiga jordbruksmetoder som ökar produktiviteten och produktionen, som bidrar till att upprätthålla ekosystemen, som stärker förmågan till anpassning till klimatförändringar, extrema väderförhållanden, torka, översvämning och andra katastrofer och som successivt förbättrar mark- och jordkvaliteten.',
        originalNameEn:
          '2.4 Senast 2030 uppnå hållbara system för livsmedelsproduktion samt införa motståndskraftiga jordbruksmetoder som ökar produktiviteten och produktionen, som bidrar till att upprätthålla ekosystemen, som stärker förmågan till anpassning till klimatförändringar, extrema väderförhållanden, torka, översvämning och andra katastrofer och som successivt förbättrar mark- och jordkvaliteten.',
      },
      {
        mainGoalCode: 2,
        code: '2_5',
        nameSv:
          'Öka livsmedelssystemets motståndskraft och/eller anpassning till klimatförändringar och extrema väderförhållanden',
        nameEn:
          'Öka livsmedelssystemets motståndskraft och/eller anpassning till klimatförändringar och extrema väderförhållanden',
        originalNameSv:
          '2.4 Senast 2030 uppnå hållbara system för livsmedelsproduktion samt införa motståndskraftiga jordbruksmetoder som ökar produktiviteten och produktionen, som bidrar till att upprätthålla ekosystemen, som stärker förmågan till anpassning till klimatförändringar, extrema väderförhållanden, torka, översvämning och andra katastrofer och som successivt förbättrar mark- och jordkvaliteten.',
        originalNameEn:
          '2.4 Senast 2030 uppnå hållbara system för livsmedelsproduktion samt införa motståndskraftiga jordbruksmetoder som ökar produktiviteten och produktionen, som bidrar till att upprätthålla ekosystemen, som stärker förmågan till anpassning till klimatförändringar, extrema väderförhållanden, torka, översvämning och andra katastrofer och som successivt förbättrar mark- och jordkvaliteten.',
      },
      {
        mainGoalCode: 2,
        code: '2_6',
        nameSv:
          'Begränsa och åtgärda livsmedelssystemets negativa miljöpåverkan',
        nameEn:
          'Begränsa och åtgärda livsmedelssystemets negativa miljöpåverkan',
        originalNameSv:
          '2.4 Senast 2030 uppnå hållbara system för livsmedelsproduktion samt införa motståndskraftiga jordbruksmetoder som ökar produktiviteten och produktionen, som bidrar till att upprätthålla ekosystemen, som stärker förmågan till anpassning till klimatförändringar, extrema väderförhållanden, torka, översvämning och andra katastrofer och som successivt förbättrar mark- och jordkvaliteten.',
        originalNameEn:
          '2.4 Senast 2030 uppnå hållbara system för livsmedelsproduktion samt införa motståndskraftiga jordbruksmetoder som ökar produktiviteten och produktionen, som bidrar till att upprätthålla ekosystemen, som stärker förmågan till anpassning till klimatförändringar, extrema väderförhållanden, torka, översvämning och andra katastrofer och som successivt förbättrar mark- och jordkvaliteten.',
      },
    ],
  },
  {
    code: 3,
    nameSv: 'Hälsa och välbefinnande',
    nameEn: 'Hälsa och välbefinnande',
    subGoals: [
      {
        mainGoalCode: 3,
        code: '3_1',
        nameSv: 'Utveckla och/eller producera vaccin och läkemedel',
        nameEn: 'Utveckla och/eller producera vaccin och läkemedel',
        originalNameSv:
          '3.b Stödja forskning om och utveckling av vaccin och läkemedel mot de smittsamma och icke-smittsamma sjukdomar som i första hand drabbar utvecklingsländer. Sörja för tillgång till ekonomiskt överkomliga grundläggande läkemedel och vaccin, i enlighet med Doha-deklarationen om TRIPS-avtalet och folkhälsa, i vilken det bekräftas att utvecklingsländerna har rätt att fullt ut utnyttja den flexibilitet som avtalet om handelsrelaterade aspekter av immaterialrätter erbjuder för att skydda folkhälsan och, framför allt, säkerställa att alla har tillgång till läkemedel.',
        originalNameEn:
          '3.b Stödja forskning om och utveckling av vaccin och läkemedel mot de smittsamma och icke-smittsamma sjukdomar som i första hand drabbar utvecklingsländer. Sörja för tillgång till ekonomiskt överkomliga grundläggande läkemedel och vaccin, i enlighet med Doha-deklarationen om TRIPS-avtalet och folkhälsa, i vilken det bekräftas att utvecklingsländerna har rätt att fullt ut utnyttja den flexibilitet som avtalet om handelsrelaterade aspekter av immaterialrätter erbjuder för att skydda folkhälsan och, framför allt, säkerställa att alla har tillgång till läkemedel.',
      },
      {
        mainGoalCode: 3,
        code: '3_2',
        nameSv: 'Minska smittspridning',
        nameEn: 'Minska smittspridning',
        originalNameSv:
          '3.3 Senast 2030 utrota epidemierna av aids, tuberkulos, malaria och försummade tropiska sjukdomar samt bekämpa hepatit, vattenburna sjukdomar och andra smittsamma sjukdomar.',
        originalNameEn:
          '3.3 Senast 2030 utrota epidemierna av aids, tuberkulos, malaria och försummade tropiska sjukdomar samt bekämpa hepatit, vattenburna sjukdomar och andra smittsamma sjukdomar.',
      },
      {
        mainGoalCode: 3,
        code: '3_3',
        nameSv: 'Förebygga och/eller behandla somatisk eller psykisk ohälsa',
        nameEn: 'Förebygga och/eller behandla somatisk eller psykisk ohälsa',
        originalNameSv:
          '3.4 Till 2030 genom förebyggande insatser och behandling minska det antal människor som dör i förtid av icke smittsamma sjukdomar med en tredjedel samt främja psykisk hälsa och välbefinnande.',
        originalNameEn:
          '3.4 Till 2030 genom förebyggande insatser och behandling minska det antal människor som dör i förtid av icke smittsamma sjukdomar med en tredjedel samt främja psykisk hälsa och välbefinnande.',
      },
      {
        mainGoalCode: 3,
        code: '3_4',
        nameSv: 'Främja psykisk hälsa och välbefinnande',
        nameEn: 'Främja psykisk hälsa och välbefinnande',
        originalNameSv:
          '3.4 Till 2030 genom förebyggande insatser och behandling minska det antal människor som dör i förtid av icke smittsamma sjukdomar med en tredjedel samt främja psykisk hälsa och välbefinnande.',
        originalNameEn:
          '3.4 Till 2030 genom förebyggande insatser och behandling minska det antal människor som dör i förtid av icke smittsamma sjukdomar med en tredjedel samt främja psykisk hälsa och välbefinnande.',
      },
      {
        mainGoalCode: 3,
        code: '3_5',
        nameSv:
          'Förebygga beroendeproblematik och/eller behandla människor med beroendeproblem',
        nameEn:
          'Förebygga beroendeproblematik och/eller behandla människor med beroendeproblem',
        originalNameSv:
          '3.5 Stärka insatserna för att förebygga och behandla drogmissbruk, inklusive narkotikamissbruk och skadligt alkoholbruk.',
        originalNameEn:
          '3.5 Stärka insatserna för att förebygga och behandla drogmissbruk, inklusive narkotikamissbruk och skadligt alkoholbruk.',
      },
      {
        mainGoalCode: 3,
        code: '3_6',
        nameSv: 'Minska skador och dödsfall i trafikolyckor',
        nameEn: 'Minska skador och dödsfall i trafikolyckor',
        originalNameSv:
          '3.6 Till 2020 halvera antalet dödsfall och skador i trafikolyckor i världen.',
        originalNameEn:
          '3.6 Till 2020 halvera antalet dödsfall och skador i trafikolyckor i världen.',
      },
      {
        mainGoalCode: 3,
        code: '3_7',
        nameSv: 'Främja god sexuell och reproduktiv hälsa för alla',
        nameEn: 'Främja god sexuell och reproduktiv hälsa för alla',
        originalNameSv:
          '3.7 Senast 2030 säkerställa att alla har tillgång till sexuell och reproduktiv hälsovård, inklusive familjeplanering, information och utbildning, och att reproduktiv hälsa integreras i nationella strategier och program.',
        originalNameEn:
          '3.7 Senast 2030 säkerställa att alla har tillgång till sexuell och reproduktiv hälsovård, inklusive familjeplanering, information och utbildning, och att reproduktiv hälsa integreras i nationella strategier och program.',
      },
      {
        mainGoalCode: 3,
        code: '3_8',
        nameSv:
          'Främja allmän tillgång till hälso- och sjukvård av god kvalitet för alla',
        nameEn:
          'Främja allmän tillgång till hälso- och sjukvård av god kvalitet för alla',
        originalNameSv:
          '3.8 Åstadkomma allmän hälso- och sjukvård för alla, som även skyddar mot ekonomisk risk, tillgång till grundläggande hälso- och sjukvård av god kvalitet liksom tillgång till säkra, effektiva och ekonomiskt överkomliga grundläggande läkemedel och vaccin av god kvalitet.',
        originalNameEn:
          '3.8 Åstadkomma allmän hälso- och sjukvård för alla, som även skyddar mot ekonomisk risk, tillgång till grundläggande hälso- och sjukvård av god kvalitet liksom tillgång till säkra, effektiva och ekonomiskt överkomliga grundläggande läkemedel och vaccin av god kvalitet.',
      },
      {
        mainGoalCode: 3,
        code: '3_9',
        nameSv:
          'Minska döds- och sjukdomsfall till följd av hälsofarliga föroreningar och kemikalier',
        nameEn:
          'Minska döds- och sjukdomsfall till följd av hälsofarliga föroreningar och kemikalier',
        originalNameSv:
          '3.9 Till 2030 väsentligt minska antalet döds- och sjukdomsfall till följd av skadliga kemikalier samt föroreningar och kontaminering av luft, vatten och mark.',
        originalNameEn:
          '3.9 Till 2030 väsentligt minska antalet döds- och sjukdomsfall till följd av skadliga kemikalier samt föroreningar och kontaminering av luft, vatten och mark.',
      },
      {
        mainGoalCode: 3,
        code: '3_10',
        nameSv:
          'Stärka förmågan att identifiera, reducera och hantera nationella och globala hälsorisker',
        nameEn:
          'Stärka förmågan att identifiera, reducera och hantera nationella och globala hälsorisker',
        originalNameSv:
          '3.d Stärka alla länders, i synnerhet utvecklingsländernas, kapacitet när det gäller tidig varning, riskreducering och hantering av nationella och globala hälsorisker.',
        originalNameEn:
          '3.d Stärka alla länders, i synnerhet utvecklingsländernas, kapacitet när det gäller tidig varning, riskreducering och hantering av nationella och globala hälsorisker.',
      },
      {
        mainGoalCode: 3,
        code: '3_11',
        nameSv: 'Främja djurs hälsa',
        nameEn: 'Främja djurs hälsa',
        originalNameSv:
          'Detta anpassade delmål är en Vinnovaproduktion och återfinns inte i Agenda 2030',
        originalNameEn:
          'Detta anpassade delmål är en Vinnovaproduktion och återfinns inte i Agenda 2030',
      },
    ],
  },
  {
    code: 4,
    nameSv: 'God utbildning för alla',
    nameEn: 'God utbildning för alla',
    subGoals: [
      {
        mainGoalCode: 4,
        code: '4_1',
        nameSv:
          'Stärka förutsättningar för alla att fullborda grund- och gymnasieutbildning av likvärdig och god kvalitet',
        nameEn:
          'Stärka förutsättningar för alla att fullborda grund- och gymnasieutbildning av likvärdig och god kvalitet',
        originalNameSv:
          '4.1 Senast 2030 säkerställa att alla flickor och pojkar fullbordar avgiftsfri och likvärdig grundskole- och gymnasieutbildning av god kvalitet som leder till relevanta och ändamålsenliga kunskaper.',
        originalNameEn:
          '4.1 Senast 2030 säkerställa att alla flickor och pojkar fullbordar avgiftsfri och likvärdig grundskole- och gymnasieutbildning av god kvalitet som leder till relevanta och ändamålsenliga kunskaper.',
      },
      {
        mainGoalCode: 4,
        code: '4_2',
        nameSv:
          'Öka antalet ungdomar och vuxna med relevant kompetens för att få/behålla anställning eller starta och driva företag',
        nameEn:
          'Öka antalet ungdomar och vuxna med relevant kompetens för att få/behålla anställning eller starta och driva företag',
        originalNameSv:
          '4.4 Till 2030 väsentligen öka det antal ungdomar och vuxna som har relevanta färdigheter, däribland tekniska färdigheter och yrkeskunnande, för sysselsättning, anständigt arbete och entreprenörskap.',
        originalNameEn:
          '4.4 Till 2030 väsentligen öka det antal ungdomar och vuxna som har relevanta färdigheter, däribland tekniska färdigheter och yrkeskunnande, för sysselsättning, anständigt arbete och entreprenörskap.',
      },
      {
        mainGoalCode: 4,
        code: '4_3',
        nameSv:
          'Främja lika tillgång till utbildning på alla nivåer för alla, oavsett kön eller bakgrund ',
        nameEn:
          'Främja lika tillgång till utbildning på alla nivåer för alla, oavsett kön eller bakgrund ',
        originalNameSv:
          '4.5 Senast 2030 avskaffa skillnaderna mellan könen inom utbildningsområdet och säkerställa lika tillgång till utbildning och yrkesutbildning på alla nivåer för utsatta personer, inklusive personer med funktionsnedsättning, ursprungsfolk och barn som lever under utsatta förhållanden.',
        originalNameEn:
          '4.5 Senast 2030 avskaffa skillnaderna mellan könen inom utbildningsområdet och säkerställa lika tillgång till utbildning och yrkesutbildning på alla nivåer för utsatta personer, inklusive personer med funktionsnedsättning, ursprungsfolk och barn som lever under utsatta förhållanden.',
      },
      {
        mainGoalCode: 4,
        code: '4_4',
        nameSv:
          'Stärka de kunskaper och färdigheter som människor behöver för att kunna bidra till en hållbar utveckling',
        nameEn:
          'Stärka de kunskaper och färdigheter som människor behöver för att kunna bidra till en hållbar utveckling',
        originalNameSv:
          '4.7 Senast 2030 säkerställa att alla studerande får de kunskaper och färdigheter som behövs för att främja en hållbar utveckling, bland annat genom utbildning för hållbar utveckling och hållbara livsstilar, mänskliga rättigheter, jämställdhet, främjande av en kultur av fred, icke-våld och globalt medborgarskap samt värdesättande av kulturell mångfald och kulturens bidrag till hållbar utveckling.',
        originalNameEn:
          '4.7 Senast 2030 säkerställa att alla studerande får de kunskaper och färdigheter som behövs för att främja en hållbar utveckling, bland annat genom utbildning för hållbar utveckling och hållbara livsstilar, mänskliga rättigheter, jämställdhet, främjande av en kultur av fred, icke-våld och globalt medborgarskap samt värdesättande av kulturell mångfald och kulturens bidrag till hållbar utveckling.',
      },
      {
        mainGoalCode: 4,
        code: '4_5',
        nameSv: 'Skapa trygga, inkluderande och ändamålsenliga lärandemiljöer ',
        nameEn: 'Skapa trygga, inkluderande och ändamålsenliga lärandemiljöer ',
        originalNameSv:
          '4.a Bygga och förbättra utbildningsmiljöer som är anpassade för barn och personer med funktionsnedsättning, samt tar hänsyn till jämställdhetsaspekter och därmed erbjuder en trygg, fredlig, inkluderande och ändamålsenlig lärandemiljö för alla.',
        originalNameEn:
          '4.a Bygga och förbättra utbildningsmiljöer som är anpassade för barn och personer med funktionsnedsättning, samt tar hänsyn till jämställdhetsaspekter och därmed erbjuder en trygg, fredlig, inkluderande och ändamålsenlig lärandemiljö för alla.',
      },
      {
        mainGoalCode: 4,
        code: '4_6',
        nameSv: 'Öka tillgången till utbildade lärare',
        nameEn: 'Öka tillgången till utbildade lärare',
        originalNameSv:
          '4.c Till 2030 väsentligen öka tillgången på utbildade lärare, bland annat genom internationellt samarbete kring lärarutbildning i utvecklingsländerna, särskilt de minst utvecklade länderna och små önationer under utveckling.',
        originalNameEn:
          '4.c Till 2030 väsentligen öka tillgången på utbildade lärare, bland annat genom internationellt samarbete kring lärarutbildning i utvecklingsländerna, särskilt de minst utvecklade länderna och små önationer under utveckling.',
      },
    ],
  },
  {
    code: 5,
    nameSv: 'Jämställdhet',
    nameEn: 'Jämställdhet',
    subGoals: [
      {
        mainGoalCode: 5,
        code: '5_1',
        nameSv:
          'Motverka alla former av våld mot och diskriminering av flickor och kvinnor',
        nameEn:
          'Motverka alla former av våld mot och diskriminering av flickor och kvinnor',
        originalNameSv:
          '5.1 Avskaffa alla former av diskriminering av alla kvinnor och flickor överallt.',
        originalNameEn:
          '5.1 Avskaffa alla former av diskriminering av alla kvinnor och flickor överallt.',
      },
      {
        mainGoalCode: 5,
        code: '5_2',
        nameSv:
          'Stärka förutsättningar till kvinnors fulla och faktiska deltagande och jämn fördelning av makt och inflytande i det ekonomiska, offentliga och politiska livet. ',
        nameEn:
          'Stärka förutsättningar till kvinnors fulla och faktiska deltagande och jämn fördelning av makt och inflytande i det ekonomiska, offentliga och politiska livet. ',
        originalNameSv:
          '5.5 Tillförsäkra kvinnor fullt och faktiskt deltagande och lika möjligheter till ledarskap på alla beslutsnivåer i det politiska, ekonomiska och offentliga livet.',
        originalNameEn:
          '5.5 Tillförsäkra kvinnor fullt och faktiskt deltagande och lika möjligheter till ledarskap på alla beslutsnivåer i det politiska, ekonomiska och offentliga livet.',
      },
      {
        mainGoalCode: 5,
        code: '5_3',
        nameSv: 'Stärka kvinnors egenmakt med hjälp av gynnsam teknik',
        nameEn: 'Stärka kvinnors egenmakt med hjälp av gynnsam teknik',
        originalNameSv:
          '5.b Öka användningen av gynnsam teknik, i synnerhet informations- och kommunikationsteknik, för att främja kvinnors egenmakt.',
        originalNameEn:
          '5.b Öka användningen av gynnsam teknik, i synnerhet informations- och kommunikationsteknik, för att främja kvinnors egenmakt.',
      },
    ],
  },
  {
    code: 6,
    nameSv: 'Rent vatten och sanitet',
    nameEn: 'Rent vatten och sanitet',
    subGoals: [
      {
        mainGoalCode: 6,
        code: '6_1',
        nameSv: 'Trygga försörjningen av säkert dricksvatten för alla',
        nameEn: 'Trygga försörjningen av säkert dricksvatten för alla',
        originalNameSv:
          '6.1 Senast 2030 uppnå allmän och rättvis tillgång till säkert och ekonomiskt överkomligt dricksvatten för alla.',
        originalNameEn:
          '6.1 Senast 2030 uppnå allmän och rättvis tillgång till säkert och ekonomiskt överkomligt dricksvatten för alla.',
      },
      {
        mainGoalCode: 6,
        code: '6_2',
        nameSv:
          'Minska föroreningar i vatten och/eller förbättra behandlingen av avloppsvatten',
        nameEn:
          'Minska föroreningar i vatten och/eller förbättra behandlingen av avloppsvatten',
        originalNameSv:
          '6.3 Till 2030 förbättra vattenkvaliteten genom att minska föroreningar, stoppa dumpning och minimera utsläpp av farliga kemikalier och material, halvera andelen obehandlat avloppsvatten och väsentligt öka återvinningen och en säker återanvändning globalt.',
        originalNameEn:
          '6.3 Till 2030 förbättra vattenkvaliteten genom att minska föroreningar, stoppa dumpning och minimera utsläpp av farliga kemikalier och material, halvera andelen obehandlat avloppsvatten och väsentligt öka återvinningen och en säker återanvändning globalt.',
      },
      {
        mainGoalCode: 6,
        code: '6_3',
        nameSv:
          'Främja en hållbar och effektiv användning av sötvatten för minskad vattenbrist',
        nameEn:
          'Främja en hållbar och effektiv användning av sötvatten för minskad vattenbrist',
        originalNameSv:
          '6.4 Till 2030 väsentligt effektivisera vattenanvändningen inom alla sektorer samt säkerställa hållbara uttag och en hållbar försörjning med sötvatten för att angripa vattenbristen och väsentligt minska det antal människor som lider av vattenbrist.',
        originalNameEn:
          '6.4 Till 2030 väsentligt effektivisera vattenanvändningen inom alla sektorer samt säkerställa hållbara uttag och en hållbar försörjning med sötvatten för att angripa vattenbristen och väsentligt minska det antal människor som lider av vattenbrist.',
      },
    ],
  },
  {
    code: 7,
    nameSv: 'Hållbar energi för alla',
    nameEn: 'Hållbar energi för alla',
    subGoals: [
      {
        mainGoalCode: 7,
        code: '7_1',
        nameSv:
          'Främja tillgång till hållbar och tillförlitlig energiförsörjning för alla',
        nameEn:
          'Främja tillgång till hållbar och tillförlitlig energiförsörjning för alla',
        originalNameSv:
          '7.1 Senast 2030 säkerställa allmän tillgång till ekonomiskt överkomliga, tillförlitliga och moderna energitjänster.',
        originalNameEn:
          '7.1 Senast 2030 säkerställa allmän tillgång till ekonomiskt överkomliga, tillförlitliga och moderna energitjänster.',
      },
      {
        mainGoalCode: 7,
        code: '7_2',
        nameSv: 'Utveckla och/eller öka produktionen av förnybar energi',
        nameEn: 'Utveckla och/eller öka produktionen av förnybar energi',
        originalNameSv:
          '7.2 Till 2030 väsentligen öka andelen förnybar energi i den globala energimixen.',
        originalNameEn:
          '7.2 Till 2030 väsentligen öka andelen förnybar energi i den globala energimixen.',
      },
      {
        mainGoalCode: 7,
        code: '7_3',
        nameSv:
          'Främja en effektivare energianvändning, inklusive effektivare bränsleanvändning',
        nameEn:
          'Främja en effektivare energianvändning, inklusive effektivare bränsleanvändning',
        originalNameSv:
          '7.3 Till 2030 fördubbla den globala förbättringstakten vad gäller energieffektivitet.',
        originalNameEn:
          '7.3 Till 2030 fördubbla den globala förbättringstakten vad gäller energieffektivitet.',
      },
    ],
  },
  {
    code: 8,
    nameSv: 'Anständiga arbetsvillkor och ekonomisk tillväxt',
    nameEn: 'Anständiga arbetsvillkor och ekonomisk tillväxt',
    subGoals: [
      {
        mainGoalCode: 8,
        code: '8_1',
        nameSv:
          'Uppnå högre produktivitet inom näringsliv och samhälle genom diversifiering, tekniska förbättringar och innovation',
        nameEn:
          'Uppnå högre produktivitet inom näringsliv och samhälle genom diversifiering, tekniska förbättringar och innovation',
        originalNameSv:
          '8.2 Uppnå högre ekonomisk produktivitet genom diversifiering, teknisk uppgradering och innovation, bland annat genom att fokusera på sektorer med högt förädlingsvärde och hög arbetsintensitet.',
        originalNameEn:
          '8.2 Uppnå högre ekonomisk produktivitet genom diversifiering, teknisk uppgradering och innovation, bland annat genom att fokusera på sektorer med högt förädlingsvärde och hög arbetsintensitet.',
      },
      {
        mainGoalCode: 8,
        code: '8_2',
        nameSv:
          'Främja att ekonomisk tillväxt frikopplas från negativ miljöpåverkan',
        nameEn:
          'Främja att ekonomisk tillväxt frikopplas från negativ miljöpåverkan',
        originalNameSv:
          '8.4 Fram till 2030 successivt förbättra den globala resurseffektiviteten i konsumtionen och produktionen samt sträva efter att bryta sambandet mellan ekonomisk tillväxt och miljöförstöring, i enlighet med det tioåriga ramverket för hållbar konsumtion och produktion, med de utvecklade länderna i täten',
        originalNameEn:
          '8.4 Fram till 2030 successivt förbättra den globala resurseffektiviteten i konsumtionen och produktionen samt sträva efter att bryta sambandet mellan ekonomisk tillväxt och miljöförstöring, i enlighet med det tioåriga ramverket för hållbar konsumtion och produktion, med de utvecklade länderna i täten',
      },
      {
        mainGoalCode: 8,
        code: '8_3',
        nameSv:
          'Möjliggöra en full och produktiv sysselsättning med anständiga arbetsvillkor för alla',
        nameEn:
          'Möjliggöra en full och produktiv sysselsättning med anständiga arbetsvillkor för alla',
        originalNameSv:
          '8.5 Senast 2030 uppnå full och produktiv sysselsättning med anständiga arbetsvillkor för alla kvinnor och män, inklusive ungdomar och personer med funktionsnedsättning, samt lika lön för likvärdigt arbete.',
        originalNameEn:
          '8.5 Senast 2030 uppnå full och produktiv sysselsättning med anständiga arbetsvillkor för alla kvinnor och män, inklusive ungdomar och personer med funktionsnedsättning, samt lika lön för likvärdigt arbete.',
      },
      {
        mainGoalCode: 8,
        code: '8_4',
        nameSv:
          'Skydda arbetstagarnas rättigheter och främja en god arbetsmiljö för alla arbetstagare',
        nameEn:
          'Skydda arbetstagarnas rättigheter och främja en god arbetsmiljö för alla arbetstagare',
        originalNameSv:
          '8.8 Skydda arbetstagarnas rättigheter och främja en trygg och säker arbetsmiljö för alla arbetstagare, inklusive arbetskraftsinvandrare, i synnerhet kvinnliga migranter, och människor i otrygga anställningar.',
        originalNameEn:
          '8.8 Skydda arbetstagarnas rättigheter och främja en trygg och säker arbetsmiljö för alla arbetstagare, inklusive arbetskraftsinvandrare, i synnerhet kvinnliga migranter, och människor i otrygga anställningar.',
      },
      {
        mainGoalCode: 8,
        code: '8_5',
        nameSv:
          'Främja hållbar turism som skapar arbetstillfällen och främjar lokal kultur och lokala produkter',
        nameEn:
          'Främja hållbar turism som skapar arbetstillfällen och främjar lokal kultur och lokala produkter',
        originalNameSv:
          '8.9 Senast 2030 utarbeta och genomföra politik för hållbar turism som skapar arbetstillfällen och främjar lokal kultur och lokala produkter.',
        originalNameEn:
          '8.9 Senast 2030 utarbeta och genomföra politik för hållbar turism som skapar arbetstillfällen och främjar lokal kultur och lokala produkter.',
      },
    ],
  },
  {
    code: 9,
    nameSv: 'Hållbar industri, innovationer och infrastruktur',
    nameEn: 'Hållbar industri, innovationer och infrastruktur',
    subGoals: [
      {
        mainGoalCode: 9,
        code: '9_1',
        nameSv:
          'Bygga och/eller utveckla en hållbar, tillförlitlig och motståndskraftig infrastruktur som skapar ökad samhällsnytta',
        nameEn:
          'Bygga och/eller utveckla en hållbar, tillförlitlig och motståndskraftig infrastruktur som skapar ökad samhällsnytta',
        originalNameSv:
          '9.1 Bygga ut tillförlitlig, hållbar och motståndskraftig infrastruktur av hög kvalitet, inklusive regional och gränsöverskridande infrastruktur, för att stödja ekonomisk utveckling och människors välbefinnande, med fokus på ekonomiskt överkomlig och rättvis tillgång för alla.',
        originalNameEn:
          '9.1 Bygga ut tillförlitlig, hållbar och motståndskraftig infrastruktur av hög kvalitet, inklusive regional och gränsöverskridande infrastruktur, för att stödja ekonomisk utveckling och människors välbefinnande, med fokus på ekonomiskt överkomlig och rättvis tillgång för alla.',
      },
      {
        mainGoalCode: 9,
        code: '9_2',
        nameSv:
          'Främja en ekonomiskt överkomlig och rättvis tillgång till infrastruktur för alla',
        nameEn:
          'Främja en ekonomiskt överkomlig och rättvis tillgång till infrastruktur för alla',
        originalNameSv:
          '9.1 Bygga ut tillförlitlig, hållbar och motståndskraftig infrastruktur av hög kvalitet, inklusive regional och gränsöverskridande infrastruktur, för att stödja ekonomisk utveckling och människors välbefinnande, med fokus på ekonomiskt överkomlig och rättvis tillgång för alla.',
        originalNameEn:
          '9.1 Bygga ut tillförlitlig, hållbar och motståndskraftig infrastruktur av hög kvalitet, inklusive regional och gränsöverskridande infrastruktur, för att stödja ekonomisk utveckling och människors välbefinnande, med fokus på ekonomiskt överkomlig och rättvis tillgång för alla.',
      },
      {
        mainGoalCode: 9,
        code: '9_3',
        nameSv:
          'Stärka små och medelstora företags möjligheter till utveckling, förädling och försäljning genom tillgång till verktyg, tjänster och nätverk',
        nameEn:
          'Stärka små och medelstora företags möjligheter till utveckling, förädling och försäljning genom tillgång till verktyg, tjänster och nätverk',
        originalNameSv:
          '9.3 Öka tillgången för småskaliga industriföretag och andra företag, i synnerhet i utvecklingsländerna, till finansiella tjänster, inklusive överkomliga krediter, samt deras integrering i värdekedjor och marknader.',
        originalNameEn:
          '9.3 Öka tillgången för småskaliga industriföretag och andra företag, i synnerhet i utvecklingsländerna, till finansiella tjänster, inklusive överkomliga krediter, samt deras integrering i värdekedjor och marknader.',
      },
      {
        mainGoalCode: 9,
        code: '9_4',
        nameSv:
          'Främja en hållbar industri genom effektivare resursanvändning, fler rena och miljövänliga tekniker och industriprocesser',
        nameEn:
          'Främja en hållbar industri genom effektivare resursanvändning, fler rena och miljövänliga tekniker och industriprocesser',
        originalNameSv:
          '9.4 Till 2030 rusta upp infrastrukturen och anpassa industrier för att göra dem hållbara, med effektivare resursanvändning och fler rena och miljövänliga tekniker och industriprocesser. Alla länder vidtar åtgärder i enlighet med sina respektive förutsättningar.',
        originalNameEn:
          '9.4 Till 2030 rusta upp infrastrukturen och anpassa industrier för att göra dem hållbara, med effektivare resursanvändning och fler rena och miljövänliga tekniker och industriprocesser. Alla länder vidtar åtgärder i enlighet med sina respektive förutsättningar.',
      },
      {
        mainGoalCode: 9,
        code: '9_5',
        nameSv:
          'Stärka forsknings-, utvecklings- och innovationsförmågan samt den tekniska kapaciteten i industrin',
        nameEn:
          'Stärka forsknings-, utvecklings- och innovationsförmågan samt den tekniska kapaciteten i industrin',
        originalNameSv:
          '9.5 Förbättra den vetenskapliga forskningen och industrisektorernas tekniska kapacitet i alla länder, i synnerhet utvecklingsländerna, bland annat genom att till 2030 uppmuntra innovation och väsentligt öka det antal personer som arbetar med forskning och utveckling per 1 miljon människor liksom de offentliga och privata utgifterna för forskning och utveckling.',
        originalNameEn:
          '9.5 Förbättra den vetenskapliga forskningen och industrisektorernas tekniska kapacitet i alla länder, i synnerhet utvecklingsländerna, bland annat genom att till 2030 uppmuntra innovation och väsentligt öka det antal personer som arbetar med forskning och utveckling per 1 miljon människor liksom de offentliga och privata utgifterna för forskning och utveckling.',
      },
    ],
  },
  {
    code: 10,
    nameSv: 'Minskad ojämlikhet',
    nameEn: 'Minskad ojämlikhet',
    subGoals: [
      {
        mainGoalCode: 10,
        code: '10_1',
        nameSv: 'Minska den ekonomiska ojämlikheten',
        nameEn: 'Minska den ekonomiska ojämlikheten',
        originalNameSv:
          '10.1 Till 2030 successivt uppnå och upprätthålla en inkomsttillväxt högre än det nationella genomsnittet för de 40 procent av befolkningen som har lägst inkomst.',
        originalNameEn:
          '10.1 Till 2030 successivt uppnå och upprätthålla en inkomsttillväxt högre än det nationella genomsnittet för de 40 procent av befolkningen som har lägst inkomst.',
      },
      {
        mainGoalCode: 10,
        code: '10_2',
        nameSv:
          'Främja att alla människor oavsett bakgrund inkluderas i det sociala, ekonomiska och politiska livet ',
        nameEn:
          'Främja att alla människor oavsett bakgrund inkluderas i det sociala, ekonomiska och politiska livet ',
        originalNameSv:
          '10.2 Till 2030 möjliggöra och verka för att alla människor, oavsett ålder, kön, funktionsnedsättning, ras, etnicitet, ursprung, religion eller ekonomisk eller annan ställning, blir inkluderade i det sociala, ekonomiska och politiska livet.',
        originalNameEn:
          '10.2 Till 2030 möjliggöra och verka för att alla människor, oavsett ålder, kön, funktionsnedsättning, ras, etnicitet, ursprung, religion eller ekonomisk eller annan ställning, blir inkluderade i det sociala, ekonomiska och politiska livet.',
      },
      {
        mainGoalCode: 10,
        code: '10_3',
        nameSv:
          'Förbättra regleringen och övervakningen av finansmarknader och finansinstitut',
        nameEn:
          'Förbättra regleringen och övervakningen av finansmarknader och finansinstitut',
        originalNameSv:
          '10.5 Förbättra regleringen och övervakningen av globala finansmarknader och finansinstitut samt stärka genomförandet av sådana regleringar.',
        originalNameEn:
          '10.5 Förbättra regleringen och övervakningen av globala finansmarknader och finansinstitut samt stärka genomförandet av sådana regleringar.',
      },
      {
        mainGoalCode: 10,
        code: '10_4',
        nameSv: 'Främja ansvarsfull och säker migration och integration',
        nameEn: 'Främja ansvarsfull och säker migration och integration',
        originalNameSv:
          '10.7 Underlätta en ordnad, säker, reglerad och ansvarsfull migration och rörlighet av personer, inklusive genom planerad och väl fungerande migrationspolitik.',
        originalNameEn:
          '10.7 Underlätta en ordnad, säker, reglerad och ansvarsfull migration och rörlighet av personer, inklusive genom planerad och väl fungerande migrationspolitik.',
      },
    ],
  },
  {
    code: 11,
    nameSv: 'Hållbara städer och samhällen',
    nameEn: 'Hållbara städer och samhällen',
    subGoals: [
      {
        mainGoalCode: 11,
        code: '11_1',
        nameSv:
          'Främja tillgång för alla till tillfredställande, säkra och ekonomiskt överkomliga bostäder',
        nameEn:
          'Främja tillgång för alla till tillfredställande, säkra och ekonomiskt överkomliga bostäder',
        originalNameSv:
          '11.1 Senast 2030 säkerställa tillgång för alla till fullgoda, säkra och ekonomiskt överkomliga bostäder och grundläggande tjänster samt rusta upp slumområden.',
        originalNameEn:
          '11.1 Senast 2030 säkerställa tillgång för alla till fullgoda, säkra och ekonomiskt överkomliga bostäder och grundläggande tjänster samt rusta upp slumområden.',
      },
      {
        mainGoalCode: 11,
        code: '11_2',
        nameSv:
          'Öka tillgången till hållbara, säkra och tillgängliga transporter och transportsystem',
        nameEn:
          'Öka tillgången till hållbara, säkra och tillgängliga transporter och transportsystem',
        originalNameSv:
          '11.2 Senast 2030 tillhandahålla tillgång till säkra, ekonomiskt överkomliga, tillgängliga och hållbara transportsystem för alla. Förbättra trafiksäkerheten, särskilt genom att bygga ut kollektivtrafiken, med särskild uppmärksamhet på behoven hos människor i utsatta situationer, kvinnor, barn, personer med funktionsnedsättning samt äldre personer.',
        originalNameEn:
          '11.2 Senast 2030 tillhandahålla tillgång till säkra, ekonomiskt överkomliga, tillgängliga och hållbara transportsystem för alla. Förbättra trafiksäkerheten, särskilt genom att bygga ut kollektivtrafiken, med särskild uppmärksamhet på behoven hos människor i utsatta situationer, kvinnor, barn, personer med funktionsnedsättning samt äldre personer.',
      },
      {
        mainGoalCode: 11,
        code: '11_3',
        nameSv: 'Förbättra trafiksäkerheten',
        nameEn: 'Förbättra trafiksäkerheten',
        originalNameSv:
          '11.2 Senast 2030 tillhandahålla tillgång till säkra, ekonomiskt överkomliga, tillgängliga och hållbara transportsystem för alla. Förbättra trafiksäkerheten, särskilt genom att bygga ut kollektivtrafiken, med särskild uppmärksamhet på behoven hos människor i utsatta situationer, kvinnor, barn, personer med funktionsnedsättning samt äldre personer.',
        originalNameEn:
          '11.2 Senast 2030 tillhandahålla tillgång till säkra, ekonomiskt överkomliga, tillgängliga och hållbara transportsystem för alla. Förbättra trafiksäkerheten, särskilt genom att bygga ut kollektivtrafiken, med särskild uppmärksamhet på behoven hos människor i utsatta situationer, kvinnor, barn, personer med funktionsnedsättning samt äldre personer.',
      },
      {
        mainGoalCode: 11,
        code: '11_4',
        nameSv:
          'Främja inkluderande och hållbar planering och förvaltning av boende och samhällen',
        nameEn:
          'Främja inkluderande och hållbar planering och förvaltning av boende och samhällen',
        originalNameSv:
          '11.3 Till 2030 verka för en inkluderande och hållbar urbanisering samt förbättra kapaciteten för deltagandebaserad, integrerad och hållbar planering och förvaltning av bosättningar i alla länder.',
        originalNameEn:
          '11.3 Till 2030 verka för en inkluderande och hållbar urbanisering samt förbättra kapaciteten för deltagandebaserad, integrerad och hållbar planering och förvaltning av bosättningar i alla länder.',
      },
      {
        mainGoalCode: 11,
        code: '11_5',
        nameSv: 'Minska städers negativa miljöpåverkan',
        nameEn: 'Minska städers negativa miljöpåverkan',
        originalNameSv:
          '11.6 Till 2030 minska städernas negativa miljöpåverkan per person, bland annat genom att ägna särskild uppmärksamhet åt luftkvalitet samt hantering av kommunalt och annat avfall.',
        originalNameEn:
          '11.6 Till 2030 minska städernas negativa miljöpåverkan per person, bland annat genom att ägna särskild uppmärksamhet åt luftkvalitet samt hantering av kommunalt och annat avfall.',
      },
      {
        mainGoalCode: 11,
        code: '11_6',
        nameSv:
          'Öka tillgången till säkra, inkluderande och tillgängliga grönområden och offentliga platser',
        nameEn:
          'Öka tillgången till säkra, inkluderande och tillgängliga grönområden och offentliga platser',
        originalNameSv:
          '11.7 Senast 2030 tillhandahålla universell tillgång till säkra, inkluderande och tillgängliga grönområden och offentliga platser, i synnerhet för kvinnor och barn, äldre personer och personer med funktionsnedsättning.',
        originalNameEn:
          '11.7 Senast 2030 tillhandahålla universell tillgång till säkra, inkluderande och tillgängliga grönområden och offentliga platser, i synnerhet för kvinnor och barn, äldre personer och personer med funktionsnedsättning.',
      },
      {
        mainGoalCode: 11,
        code: '11_7',
        nameSv:
          'Främja positiva ekonomiska, sociala och miljömässiga kopplingar mellan stad, stadsnära områden och landsbygd',
        nameEn:
          'Främja positiva ekonomiska, sociala och miljömässiga kopplingar mellan stad, stadsnära områden och landsbygd',
        originalNameSv:
          '11.a Främja positiva ekonomiska, sociala och miljömässiga kopplingar mellan stadsområden, stadsnära områden och landsbygdsområden genom att stärka den nationella och regionala utvecklingsplaneringen.',
        originalNameEn:
          '11.a Främja positiva ekonomiska, sociala och miljömässiga kopplingar mellan stadsområden, stadsnära områden och landsbygdsområden genom att stärka den nationella och regionala utvecklingsplaneringen.',
      },
      {
        mainGoalCode: 11,
        code: '11_8',
        nameSv:
          'Stärka städers och samhällens förmåga att anpassa sig till klimatförändringarna och öka sin motståndskraft mot katastrofer',
        nameEn:
          'Stärka städers och samhällens förmåga att anpassa sig till klimatförändringarna och öka sin motståndskraft mot katastrofer',
        originalNameSv:
          '11.b Till 2020 väsentligen öka det antal städer och samhällen som antar och genomför integrerade strategier och planer för inkludering, resurseffektivitet, begränsning av och anpassning till klimatförändringarna och motståndskraft mot katastrofer samt utveckla och genomföra, i linje med Sendai-ramverket för katastrofriskreducering 2015–2030, en samlad katastrofriskhantering på alla nivåer.',
        originalNameEn:
          '11.b Till 2020 väsentligen öka det antal städer och samhällen som antar och genomför integrerade strategier och planer för inkludering, resurseffektivitet, begränsning av och anpassning till klimatförändringarna och motståndskraft mot katastrofer samt utveckla och genomföra, i linje med Sendai-ramverket för katastrofriskreducering 2015–2030, en samlad katastrofriskhantering på alla nivåer.',
      },
    ],
  },
  {
    code: 12,
    nameSv: 'Hållbar konsumtion och produktion',
    nameEn: 'Hållbar konsumtion och produktion',
    subGoals: [
      {
        mainGoalCode: 12,
        code: '12_1',
        nameSv:
          'Uppnå hållbar och effektiv förvaltning och användning av naturresurser',
        nameEn:
          'Uppnå hållbar och effektiv förvaltning och användning av naturresurser',
        originalNameSv:
          '12.2 Senast 2030 uppnå en hållbar förvaltning och ett effektivt nyttjande av naturresurser.',
        originalNameEn:
          '12.2 Senast 2030 uppnå en hållbar förvaltning och ett effektivt nyttjande av naturresurser.',
      },
      {
        mainGoalCode: 12,
        code: '12_2',
        nameSv: 'Minska matsvinnet genom hela livsmedelskedjan',
        nameEn: 'Minska matsvinnet genom hela livsmedelskedjan',
        originalNameSv:
          '12.3 Till 2030, halvera det globala matsvinnet per person i butik- och konsumentledet, och minska matsvinnet längs hela livsmedelskedjan, även förlusterna efter skörd.',
        originalNameEn:
          '12.3 Till 2030, halvera det globala matsvinnet per person i butik- och konsumentledet, och minska matsvinnet längs hela livsmedelskedjan, även förlusterna efter skörd.',
      },
      {
        mainGoalCode: 12,
        code: '12_3',
        nameSv:
          'Uppnå miljövänlig hantering av kemikalier och annat avfall under hela deras livscykel inklusive minskade utsläpp i luft, vatten och mark',
        nameEn:
          'Uppnå miljövänlig hantering av kemikalier och annat avfall under hela deras livscykel inklusive minskade utsläpp i luft, vatten och mark',
        originalNameSv:
          '12.4 Senast 2020 uppnå miljövänlig hantering av kemikalier och alla typer av avfall under hela deras livscykel, i enlighet med överenskomna internationella ramverket, samt avsevärt minska utsläppen av dem i luft, vatten och mark i syfte att minimera deras negativa konsekvenser för människors hälsa och miljön.',
        originalNameEn:
          '12.4 Senast 2020 uppnå miljövänlig hantering av kemikalier och alla typer av avfall under hela deras livscykel, i enlighet med överenskomna internationella ramverket, samt avsevärt minska utsläppen av dem i luft, vatten och mark i syfte att minimera deras negativa konsekvenser för människors hälsa och miljön.',
      },
      {
        mainGoalCode: 12,
        code: '12_4',
        nameSv:
          'Minska mängden avfall genom åtgärder för att förebygga, återanvända och återvinna avfall',
        nameEn:
          'Minska mängden avfall genom åtgärder för att förebygga, återanvända och återvinna avfall',
        originalNameSv:
          '12.5 Till 2030 väsentligt minska mängden avfall genom åtgärder för att förebygga, minska, återanvända och återvinna avfall.',
        originalNameEn:
          '12.5 Till 2030 väsentligt minska mängden avfall genom åtgärder för att förebygga, minska, återanvända och återvinna avfall.',
      },
      {
        mainGoalCode: 12,
        code: '12_5',
        nameSv:
          'Möjliggöra/underlätta införandet av hållbara metoder och hållbarhetsrapportering i verksamheter',
        nameEn:
          'Möjliggöra/underlätta införandet av hållbara metoder och hållbarhetsrapportering i verksamheter',
        originalNameSv:
          '12.6 Uppmuntra företag, särskilt stora och multinationella företag, att införa hållbara metoder och att integrera hållbarhetsinformation i sin rapporteringscykel.',
        originalNameEn:
          '12.6 Uppmuntra företag, särskilt stora och multinationella företag, att införa hållbara metoder och att integrera hållbarhetsinformation i sin rapporteringscykel.',
      },
      {
        mainGoalCode: 12,
        code: '12_6',
        nameSv: 'Integrera ett hållbarhetsperspektiv i offentlig upphandling',
        nameEn: 'Integrera ett hållbarhetsperspektiv i offentlig upphandling',
        originalNameSv:
          '12.7 Främja hållbara offentliga upphandlingsmetoder, i enlighet med nationell politik och nationella prioriteringar.',
        originalNameEn:
          '12.7 Främja hållbara offentliga upphandlingsmetoder, i enlighet med nationell politik och nationella prioriteringar.',
      },
      {
        mainGoalCode: 12,
        code: '12_7',
        nameSv:
          'Stärka förutsättningar för människor att ändra sina beteenden för mer hållbara livsstilar',
        nameEn:
          'Stärka förutsättningar för människor att ändra sina beteenden för mer hållbara livsstilar',
        originalNameSv:
          '12.8 Senast 2030 säkerställa att människor överallt har den information och medvetenhet som behövs för en hållbar utveckling och livsstilar i harmoni med naturen.',
        originalNameEn:
          '12.8 Senast 2030 säkerställa att människor överallt har den information och medvetenhet som behövs för en hållbar utveckling och livsstilar i harmoni med naturen.',
      },
      {
        mainGoalCode: 12,
        code: '12_8',
        nameSv:
          'Utveckla och/eller införa verktyg för att stödja arbetet för en hållbar turism',
        nameEn:
          'Utveckla och/eller införa verktyg för att stödja arbetet för en hållbar turism',
        originalNameSv:
          '12.b Utveckla och genomföra verktyg för att övervaka hur en hållbar utveckling påverkar en hållbar turism som skapar arbetstillfällen och främjar lokal kultur och lokala produkter.',
        originalNameEn:
          '12.b Utveckla och genomföra verktyg för att övervaka hur en hållbar utveckling påverkar en hållbar turism som skapar arbetstillfällen och främjar lokal kultur och lokala produkter.',
      },
      {
        mainGoalCode: 12,
        code: '12_9',
        nameSv:
          'Öka utvecklingen, produktionen och användningen av material som bidrar till en hållbar utveckling',
        nameEn:
          'Öka utvecklingen, produktionen och användningen av material som bidrar till en hållbar utveckling',
        originalNameSv:
          'Detta anpassade delmål är en Vinnovaproduktion och återfinns inte i Agenda 2030',
        originalNameEn:
          'Detta anpassade delmål är en Vinnovaproduktion och återfinns inte i Agenda 2030',
      },
    ],
  },
  {
    code: 13,
    nameSv: 'Bekämpa klimatförändringen',
    nameEn: 'Bekämpa klimatförändringen',
    subGoals: [
      {
        mainGoalCode: 13,
        code: '13_1',
        nameSv: 'Integrera klimatåtgärder i planering, strategier och policy',
        nameEn: 'Integrera klimatåtgärder i planering, strategier och policy',
        originalNameSv:
          '13.2 Integrera klimatåtgärder i politik, strategier och planering på nationell nivå.',
        originalNameEn:
          '13.2 Integrera klimatåtgärder i politik, strategier och planering på nationell nivå.',
      },
      {
        mainGoalCode: 13,
        code: '13_2',
        nameSv:
          'Öka medvetenhet kring och kapacitet att begränsa klimatförändringarna och deras effekter',
        nameEn:
          'Öka medvetenhet kring och kapacitet att begränsa klimatförändringarna och deras effekter',
        originalNameSv:
          '13.3 Förbättra utbildningen, medvetenheten och den mänskliga och institutionella kapaciteten vad gäller begränsning av klimatförändringarna, klimatanpassning, begränsning av klimatförändringarnas konsekvenser samt tidig varning.',
        originalNameEn:
          '13.3 Förbättra utbildningen, medvetenheten och den mänskliga och institutionella kapaciteten vad gäller begränsning av klimatförändringarna, klimatanpassning, begränsning av klimatförändringarnas konsekvenser samt tidig varning.',
      },
    ],
  },
  {
    code: 14,
    nameSv: 'Hav och marina resurser',
    nameEn: 'Hav och marina resurser',
    subGoals: [
      {
        mainGoalCode: 14,
        code: '14_1',
        nameSv:
          'Förebygga och minska alla föroreningar i havet, inklusive marint skräp och tillförsel av näringsämnen',
        nameEn:
          'Förebygga och minska alla föroreningar i havet, inklusive marint skräp och tillförsel av näringsämnen',
        originalNameSv:
          '14.1 Till 2025 förebygga och avsevärt minska alla slags föroreningar i havet, i synnerhet från landbaserad verksamhet, inklusive marint skräp och tillförsel av näringsämnen.',
        originalNameEn:
          '14.1 Till 2025 förebygga och avsevärt minska alla slags föroreningar i havet, i synnerhet från landbaserad verksamhet, inklusive marint skräp och tillförsel av näringsämnen.',
      },
      {
        mainGoalCode: 14,
        code: '14_2',
        nameSv: 'Skydda och återställa marina och kustnära ekosystem',
        nameEn: 'Skydda och återställa marina och kustnära ekosystem',
        originalNameSv:
          '14.2 Senast 2020 förvalta och skydda marina och kustnära ekosystem på ett hållbart sätt för att undvika betydande negativa konsekvenser, bland annat genom att stärka deras motståndskraft, samt vidta åtgärder för att återställa dem i syfte att uppnå friska och produktiva hav.',
        originalNameEn:
          '14.2 Senast 2020 förvalta och skydda marina och kustnära ekosystem på ett hållbart sätt för att undvika betydande negativa konsekvenser, bland annat genom att stärka deras motståndskraft, samt vidta åtgärder för att återställa dem i syfte att uppnå friska och produktiva hav.',
      },
      {
        mainGoalCode: 14,
        code: '14_3',
        nameSv: 'Begränsa och åtgärda havsförsurningens konsekvenser',
        nameEn: 'Begränsa och åtgärda havsförsurningens konsekvenser',
        originalNameSv:
          '14.3 Minimera och åtgärda havsförsurningens konsekvenser, bland annat genom ökat vetenskapligt samarbete på alla nivåer.',
        originalNameEn:
          '14.3 Minimera och åtgärda havsförsurningens konsekvenser, bland annat genom ökat vetenskapligt samarbete på alla nivåer.',
      },
    ],
  },
  {
    code: 15,
    nameSv: 'Ekosystem och biologisk mångfald',
    nameEn: 'Ekosystem och biologisk mångfald',
    subGoals: [
      {
        mainGoalCode: 15,
        code: '15_1',
        nameSv:
          'Bevara, återställa och hållbart använda ekosystem och dess ekosystemtjänster, på land och i sötvatten',
        nameEn:
          'Bevara, återställa och hållbart använda ekosystem och dess ekosystemtjänster, på land och i sötvatten',
        originalNameSv:
          '15.1 Till 2020 bevara, återställa och hållbart använda ekosystem på land och i sötvatten och deras ekosystemtjänster, särskilt skogar, våtmarker, berg och torra områden, i enlighet med de skyldigheter som anges i internationella överenskommelser.',
        originalNameEn:
          '15.1 Till 2020 bevara, återställa och hållbart använda ekosystem på land och i sötvatten och deras ekosystemtjänster, särskilt skogar, våtmarker, berg och torra områden, i enlighet med de skyldigheter som anges i internationella överenskommelser.',
      },
      {
        mainGoalCode: 15,
        code: '15_2',
        nameSv:
          'Främja hållbart skogsbruk, inklusive ökad ny- och återbeskogning',
        nameEn:
          'Främja hållbart skogsbruk, inklusive ökad ny- och återbeskogning',
        originalNameSv:
          '15.2 Till 2020 främja genomförandet av hållbart brukande av alla typer av skogar, stoppa avskogningen, återställa utarmade skogar och kraftigt öka nybeskogningen och återbeskogningen i hela världen.',
        originalNameEn:
          '15.2 Till 2020 främja genomförandet av hållbart brukande av alla typer av skogar, stoppa avskogningen, återställa utarmade skogar och kraftigt öka nybeskogningen och återbeskogningen i hela världen.',
      },
      {
        mainGoalCode: 15,
        code: '15_3',
        nameSv: 'Återställa förstörd mark och jord',
        nameEn: 'Återställa förstörd mark och jord',
        originalNameSv:
          '15.3 Till 2030 bekämpa ökenspridning, återställa förstörd mark och jord, inklusive mark som drabbats av ökenspridning, torka och översvämningar, samt sträva efter att uppnå en värld utan nettoförstöring av mark.',
        originalNameEn:
          '15.3 Till 2030 bekämpa ökenspridning, återställa förstörd mark och jord, inklusive mark som drabbats av ökenspridning, torka och översvämningar, samt sträva efter att uppnå en värld utan nettoförstöring av mark.',
      },
      {
        mainGoalCode: 15,
        code: '15_4',
        nameSv:
          'Integrera värdet av biologisk mångfald och ekosystem i planerings- och utvecklingsprocesser',
        nameEn:
          'Integrera värdet av biologisk mångfald och ekosystem i planerings- och utvecklingsprocesser',
        originalNameSv:
          '15.9 Senast 2020 integrera ekosystemens och den biologiska mångfaldens värden i nationella och lokala planerings- och utvecklingsprocesser, strategier för fattigdomsminskning samt räkenskaper.',
        originalNameEn:
          '15.9 Senast 2020 integrera ekosystemens och den biologiska mångfaldens värden i nationella och lokala planerings- och utvecklingsprocesser, strategier för fattigdomsminskning samt räkenskaper.',
      },
    ],
  },
  {
    code: 16,
    nameSv: 'Fredliga och inkluderande samhällen',
    nameEn: 'Fredliga och inkluderande samhällen',
    subGoals: [
      {
        mainGoalCode: 16,
        code: '16_1',
        nameSv:
          'Främja ökad trygghet och allmän säkerhet samt minska brottsligheten',
        nameEn:
          'Främja ökad trygghet och allmän säkerhet samt minska brottsligheten',
        originalNameSv:
          '16.4 Till 2030 avsevärt minska de olagliga finansiella flödena och vapenflödena, öka möjligheterna att återvinna och återfå stulna tillgångar samt bekämpa alla former av organiserad brottslighet.',
        originalNameEn:
          '16.4 Till 2030 avsevärt minska de olagliga finansiella flödena och vapenflödena, öka möjligheterna att återvinna och återfå stulna tillgångar samt bekämpa alla former av organiserad brottslighet.',
      },
      {
        mainGoalCode: 16,
        code: '16_2',
        nameSv:
          'Öka effektiviteten, transparensen och ansvarsskyldigheten på alla nivåer i offentlig sektor',
        nameEn:
          'Öka effektiviteten, transparensen och ansvarsskyldigheten på alla nivåer i offentlig sektor',
        originalNameSv:
          '16.6 Bygga upp effektiva och transparenta institutioner med ansvarsutkrävande på alla nivåer.',
        originalNameEn:
          '16.6 Bygga upp effektiva och transparenta institutioner med ansvarsutkrävande på alla nivåer.',
      },
      {
        mainGoalCode: 16,
        code: '16_3',
        nameSv:
          'Främja inkluderande, deltagarbaserat och representativt beslutsfattande på alla nivåer',
        nameEn:
          'Främja inkluderande, deltagarbaserat och representativt beslutsfattande på alla nivåer',
        originalNameSv:
          '16.7 Säkerställa ett lyhört, inkluderande, deltagandebaserat och representativt beslutsfattande på alla nivåer.',
        originalNameEn:
          '16.7 Säkerställa ett lyhört, inkluderande, deltagandebaserat och representativt beslutsfattande på alla nivåer.',
      },
      {
        mainGoalCode: 16,
        code: '16_4',
        nameSv:
          'Stärka demokratin genom allmän tillgång till information och skydd av grundläggande friheter',
        nameEn:
          'Stärka demokratin genom allmän tillgång till information och skydd av grundläggande friheter',
        originalNameSv:
          '16.10 Säkerställa allmän tillgång till information och skydda grundläggande friheter, i enlighet med nationell lagstiftning och internationella avtal.',
        originalNameEn:
          '16.10 Säkerställa allmän tillgång till information och skydda grundläggande friheter, i enlighet med nationell lagstiftning och internationella avtal.',
      },
    ],
  },
  {
    code: 17,
    nameSv: 'Genomförande och globalt partnerskap',
    nameEn: 'Genomförande och globalt partnerskap',
    subGoals: [
      {
        mainGoalCode: 17,
        code: '17_1',
        nameSv:
          'Öka tillförseln av finansiella resurser till utvecklingsländer för att möjliggöra en hållbar utveckling',
        nameEn:
          'Öka tillförseln av finansiella resurser till utvecklingsländer för att möjliggöra en hållbar utveckling',
        originalNameSv:
          '17.3 Mobilisera additionella finansiella resurser till utvecklingsländerna från många olika källor.',
        originalNameEn:
          '17.3 Mobilisera additionella finansiella resurser till utvecklingsländerna från många olika källor.',
      },
      {
        mainGoalCode: 17,
        code: '17_2',
        nameSv: 'Föra en mer samstämmig politik för hållbar utveckling',
        nameEn: 'Föra en mer samstämmig politik för hållbar utveckling',
        originalNameSv:
          '17.14 Föra en mer samstämmig politik för hållbar utveckling',
        originalNameEn:
          '17.14 Föra en mer samstämmig politik för hållbar utveckling',
      },
      {
        mainGoalCode: 17,
        code: '17_3',
        nameSv:
          'Främja en hållbar utveckling genom stärkta internationella partnerskap som mobiliserar och utbyter kunskap och finansiella resurser',
        nameEn:
          'Främja en hållbar utveckling genom stärkta internationella partnerskap som mobiliserar och utbyter kunskap och finansiella resurser',
        originalNameSv:
          '17.16 Stärka det globala partnerskapet för hållbar utveckling och komplettera det med partnerskap mellan flera parter som mobiliserar och utbyter kunskap, expertis, teknik och finansiella resurser, för att bidra till att målen för hållbar utveckling nås i alla länder, i synnerhet utvecklingsländer.',
        originalNameEn:
          '17.16 Stärka det globala partnerskapet för hållbar utveckling och komplettera det med partnerskap mellan flera parter som mobiliserar och utbyter kunskap, expertis, teknik och finansiella resurser, för att bidra till att målen för hållbar utveckling nås i alla länder, i synnerhet utvecklingsländer.',
      },
      {
        mainGoalCode: 17,
        code: '17_4',
        nameSv:
          'Uppmuntra och främja effektiva partnerskap mellan aktörer från offentlig, privat och ideell sektor',
        nameEn:
          'Uppmuntra och främja effektiva partnerskap mellan aktörer från offentlig, privat och ideell sektor',
        originalNameSv:
          '17.17 Uppmuntra och främja effektiva offentliga och offentlig-privata partnerskap samt partnerskap inom det civila samhället vilka bygger på erfarenheterna från andra partnerskap och deras finansieringsstrategier.',
        originalNameEn:
          '17.17 Uppmuntra och främja effektiva offentliga och offentlig-privata partnerskap samt partnerskap inom det civila samhället vilka bygger på erfarenheterna från andra partnerskap och deras finansieringsstrategier.',
      },
    ],
  },
];
